import { Box, Button, Card, CardContent, Divider, Link } from '@mui/material'
import CommentTypeIcon, { LegendBar } from '../View/CommentTypeIcon'
import { useNavigate } from 'react-router-dom'
import {
  Delete,
  Edit,
  FileOpen,
  HowToVote,
  Info,
  PersonAdd
} from '@mui/icons-material'
import { useEffect } from 'react'
import { logEvent } from 'firebase/analytics'
import Examples from '../Pulse/Helpers/Examples'

const Help = ({ analytics }) => {
  const navigate = useNavigate()

  useEffect(() => {
    logEvent(analytics, 'help')
  }, [])
  return (
    <Card
      raised
      sx={{
        margin: { md: 2, xs: 1 },
        marginTop: { xs: 2 }
      }}
    >
      <CardContent sx={{ width: 'min(1500px, 100%)', m: 'auto' }}>
        <Box sx={{ textAlign: 'center', color: 'primary.main' }}>
          <h3>Engage, Revise, Empower</h3>
          <h1>Using Community Document</h1>
        </Box>
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            gap: '8px',
            color: 'primary.main'
          }}
        >
          <FileOpen /> <h3>Documents</h3>
        </Box>
        <p style={{ marginTop: '0' }}>
          Using the control bar, you can change pages, zoom, filter comments and
          toggle fullscreen mode.
          <br />
          <br />
          <b>Filtering Comments:</b> You can filter comments by type, it is
          defaulted to show only your own comments. Select the type from the
          "Comment Filter" dropdown menu to see other options like: All, Yours,
          None, Questions, Likes, and Comments.
          <br />
          <br />
          <b>
            Comments in full screen mode are not positioned accurately
            horizontally. Please exit full screen mode to view comments in their
            correct positions.
          </b>{' '}
          Click anywhere on the document to add a comment, a question or a like.
          Click an icon on the document to view comments and reply to them.
          <br />
        </p>
        <LegendBar />

        <Button
          onClick={() => navigate('/view/howtouse')}
          variant='contained'
          sx={{ marginRight: 1, marginBottom: { xs: 1, md: 0 } }}
        >
          How To Use Community Document Example
        </Button>
        <Divider component='div' sx={{ width: '100%', mt: 2 }} />
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            gap: '8px',
            color: 'secondary.main'
          }}
        >
          <HowToVote /> <h3>Pulses</h3>
        </Box>
        <p style={{ marginTop: '0' }}>
          Sections use accordions to group related prompts together. Click on
          any section title to expand or collapse its contents. Inside each
          section, you'll see optional subheaders and descriptions followed by a
          list of prompts.
          <br />
          <br />
          Pulse's can have groupings of sections. If a Pulse has groupings,
          you'll see a tab bar at the top of the Pulse. Each tab represents a
          section grouping. Click on a tab to view sections in that grouping or
          use the all tab to view all sections. If you are on the all tab,
          you'll see all of the sections and each section will have an icon with
          a tooltip to show the grouping title.
          <br />
          <br />
          Pulse section's can have images that will display at the top of the
          section. Click on the image to view a larger version.
          <br />
          <br />
          <Examples showSpecificSection={false} />
          <b>
            After, you can click your response, or the edit button (
            <Edit sx={{ verticalAlign: 'bottom' }} />) on your comment, and a
            modal will open where you can:
          </b>
          <br />
          <span
            style={{
              display: 'flex',
              alignItems: 'center',
              gap: '8px',
              marginBottom: '8px'
            }}
          >
            <CommentTypeIcon type='comment' /> Add a comment to your response.
          </span>
          You can remove your response by clicking the delete button (
          <Delete color='error' sx={{ verticalAlign: 'bottom' }} />)
          <br />
          <br />
          <b>
            After responding, you'll be able to view overall results for that
            prompt.{' '}
          </b>
          Respond to as many or as few prompts as you like. Your responses
          contribute to the overall results, but you can skip any prompt that
          doesn't apply to you.
          <br />
          <br />
          If enabled, you can also see comments and questions from other
          participants. Filter responses by response option, all or just yours.
          <br />
        </p>

        <Button
          onClick={() => navigate('/viewPulse/howtouse')}
          variant='contained'
          color='secondary'
          sx={{ marginRight: 1, marginBottom: { xs: 1, md: 0 } }}
        >
          How To Use Community Pulse Example
        </Button>
        <br />
        <br />
        <Divider component='div' sx={{ width: '100%', mt: 2 }} />
        <br />
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            gap: '8px',
            color: 'primary.main'
          }}
        >
          <PersonAdd /> <h3>Create An Account</h3>
        </Box>
        <p style={{ marginTop: '0' }}>
          <Button
            onClick={() => navigate('/signin')}
            variant='contained'
            sx={{ mr: 2 }}
          >
            Sign In
          </Button>
          <Button onClick={() => navigate('/signup')} variant='contained'>
            Sign Up
          </Button>
          <br />
          <br />
          <i>
            Requiring sign-ins for commenting helps maintain a respectful and
            accountable community, fostering meaningful interactions while
            deterring spam and inappropriate behavior.
          </i>
        </p>
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            gap: '8px',
            color: 'primary.main'
          }}
        >
          <Delete /> <h3>Delete An Account</h3>
        </Box>
        <p style={{ marginTop: '0' }}>
          Contact{' '}
          <Link href='mailto:delete.request@communitydocument.com'>
            delete.request@communitydocument.com
          </Link>{' '}
          to delete your account.
        </p>
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            gap: '8px',
            color: 'primary.main',
            flexWrap: 'wrap'
          }}
        >
          <Box
            sx={{
              display: 'flex',
              alignItems: 'center',
              gap: '8px',
              color: 'primary.main'
            }}
          >
            <Info /> <h3>Need More Information or Help:</h3>
          </Box>
        </Box>

        <Button
          onClick={() => navigate('/support/contact')}
          variant='contained'
          sx={{ mt: 1, mr: 2 }}
        >
          Contact Us
        </Button>
        <Button
          onClick={() => navigate('/signupadmin')}
          variant='contained'
          sx={{ mt: 1, mr: 2 }}
        >
          Admin Sign Up
        </Button>
        <Button
          onClick={() => navigate('/support/adminhelp')}
          variant='contained'
          sx={{ mt: 1 }}
        >
          Upload Help
        </Button>
      </CardContent>
    </Card>
  )
}

export default Help
